<template>
  <b-card id="page-add-product" no-body class="order-products-card">
    <b-card-header class="products-card-header">
      <div class="products-heading">
        <div class="products-heading-icon">
          <feather-icon icon="PackageIcon" size="19" />
        </div>
        <div>
          <h4 class="mb-25">{{ $t(label("products")) }}</h4>
          <small class="text-muted">{{ $t(label("productsHelp")) }}</small>
        </div>
      </div>

      <b-button
        v-if="option === 1"
        variant="primary"
        @click="actualProducts(items, productsSelected)"
        v-b-modal.modal-products-list
      >
        {{ $t("add") + " " + $t(label("products")) }}
      </b-button>
    </b-card-header>

    <b-card-body class="products-card-body">
      <!-- table for desktop devices -->
      <b-table
        v-if="!!seletedProductsFunction && seletedProductsFunction.length !== 0"
        class="table-container-first d-none d-md-table shadow-sm !rounded"
        :class="{ 'mt-2': option === 1 }"
        id="products-selected-table-edit"
        responsive
        :head-variant="headVariant"
        :striped="striped"
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :items="seletedProductsFunction"
        :fields="fieldsDesktop"
      >
        <template #head()="data">
          <span class="text-black">{{
            $t(labelHeader(data.label.toLowerCase()))
          }}</span>
        </template>

        <template #cell(nombre)="data">
          <slot name="cell-nombre" :data="data">
            {{ data.item.nombre || "N/A" }}
          </slot>
        </template>

        <template #cell(price)="data">
          <div v-if="isComboPromotion(data.item)" class="d-flex flex-column">
            <span>
              {{ formatAmount(regularPrice(data.item)) }} {{ divisa }}
            </span>
          </div>
          <div
            v-else-if="promotionApplies(data.item)"
            class="d-flex flex-column"
          >
            <small class="text-muted text-line-through">
              {{ formatAmount(regularPrice(data.item)) }} {{ divisa }}
            </small>
            <strong class="text-success">
              {{ formatAmount(effectivePrice(data.item)) }} {{ divisa }}
            </strong>
          </div>
          <span v-else>
            {{ formatAmount(regularPrice(data.item)) }} {{ divisa }}
          </span>
        </template>

        <template #cell(promotion)="data">
          <div v-if="promotionApplies(data.item)" class="promotion-cell">
            <b-badge pill variant="light-success">
              {{ data.item.namePromotion || $t(label("promotion")) }}
            </b-badge>
            <small v-if="promotionCondition(data.item)" class="d-block mt-50 text-muted">
              {{ promotionCondition(data.item) }}
            </small>
          </div>
          <span v-else class="text-muted">-</span>
        </template>

        <template #cell(quantity)="data">
          <div class="w-50" v-if="option !== 2 && !blockStatus">
            <b-form-input
              v-model="data.item.quantity"
              id="cuantity"
              type="number"
              @blur="addProduct(data)"
            ></b-form-input>
            <small v-if="isValidQuantity(data.item)" class="text-danger">
              {{ $t("pleaseEnterValidAmount") }}
            </small>
          </div>
          <div v-if="option === 2">
            {{ data.item.quantity }}
          </div>
        </template>

        <template #cell(total)="data">
          {{ formatAmount(productTotal(data.item)) }} {{ divisa }}
        </template>

        <template #cell(actions)="data">
          <feather-icon
            class="text-danger mr-25"
            size="18"
            icon="TrashIcon"
            @click="onDelete(data)"
          />
        </template>
      </b-table>

      <!-- List for mobile devices -->
      <div
        v-if="!!seletedProductsFunction && seletedProductsFunction.length !== 0"
        id="list-container"
        class="d-block d-md-none list-container"
        :class="{ 'mt-1': option === 1 }"
      >
        <b-list-group>
          <b-list-group-item
            v-for="item in seletedProductsFunction"
            :key="item.idProducto"
            class="flex-column align-items-start border border-primary rounded mb-1"
          >
            <div class="d-flex w-100 justify-content-between m-0 p-0">
              <p class="!mb-0">
                <strong> {{ item.name }}</strong>
              </p>

              <b-dropdown
                variant="link"
                no-caret
                class="chart-dropdown"
                toggle-class="p-0"
                right
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="18"
                    class="text-body cursor-pointer"
                  />
                </template>
                <b-dropdown-item @click="onDelete(data)">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    {{ $t("delete") }}
                    <feather-icon
                      class="text-primary mr-25"
                      size="18"
                      icon="TrashIcon"
                    />
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <div v-if="promotionApplies(item)" class="my-1">
              <b-badge pill variant="light-success">
                {{ item.namePromotion || $t(label("promotion")) }}
              </b-badge>
              <small v-if="promotionCondition(item)" class="d-block mt-50 text-muted">
                {{ promotionCondition(item) }}
              </small>
            </div>
            {{ $t(labelHeader("unit_price")) }} :
            <template v-if="isComboPromotion(item)">
              {{ formatAmount(regularPrice(item)) }} {{ divisa }}
            </template>
            <template v-else-if="promotionApplies(item)">
              <span class="text-muted text-line-through">
                {{ formatAmount(regularPrice(item)) }} {{ divisa }}
              </span>
              <strong class="ml-50 text-success">
                {{ formatAmount(effectivePrice(item)) }} {{ divisa }}
              </strong>
            </template>
            <template v-else>
              {{ formatAmount(regularPrice(item)) }} {{ divisa }}
            </template>
            <br />
            <div class="d-flex justify-content-between align-items-center">
              <span> {{ $t(labelHeader("quantity")) }} : </span>
              <span v-if="option !== 1">
                {{ item.quantity }}
              </span>

              <div v-if="option === 1">
                <b-form-input
                  v-model="item.quantity"
                  id="cuantity"
                  type="number"
                  style="width: 6rem"
                ></b-form-input>
              </div>
            </div>
            <br />
            {{ $t(labelHeader("total")) }} :
            {{ formatAmount(productTotal(item)) }} {{ divisa }} <br />
          </b-list-group-item>
          <b-list-group-item v-if="items.length == 0" class="text-center">
            {{ $t("notRegister") }}
          </b-list-group-item>
          <b-list-group-item v-if="loading" class="text-center">
            <b-spinner variant="success"></b-spinner>
          </b-list-group-item>
        </b-list-group>
      </div>

      <!-- Modal -->
      <b-modal
        id="modal-products-list"
        hide-footer
        :title="$t('listsOf') + ' ' + $t(label('products'))"
        class="p-0"
        size="xl"
        centered
      >
        <b-card id="card-products-list" class="p-0">
          <b-card-header class="px-0 pt-0">
            <b-form-input
              id="price"
              style="width: 50% !important"
              v-model="produtFilter"
              @input="onProductSearch"
              :placeholder="$t('search') + ' ' + $t(label('product'))"
            />
          </b-card-header>
          <b-card-body
            class="table-container p-0"
            @scroll="handleScroll"
            ref="tableContainer"
          >
            <!-- table for desktop devices -->
            <b-table
              id="products-table-modal"
              responsive
              :head-variant="headVariant"
              :striped="striped"
              :bordered="bordered"
              :borderless="borderless"
              :outlined="outlined"
              :busy="loading"
              :items="items"
              :fields="fieldsModalDesktop"
              class="d-none d-md-table shadow-sm !rounded"
            >
              <template #head()="data">
                <span class="text-black">{{
                  $t(labelHeader(data.label.toLowerCase()))
                }}</span>
              </template>

              <template #cell(select)="data">
                <div class="d-flex justify-content-center">
                  <input
                    :checked="data.item.selected || false"
                    type="checkbox"
                    @click="toggleSelect(data)"
                  />
                </div>
              </template>

              <!-- <template #cell(photo)="data">
                <div
                  v-if="photoValidate"
                  class="d-flex justify-content-center"
                >
                  <img :src="data.item.photos[0].urlPhoto" :alt="'producto-img' + data.item.idProducto" />
                </div>
              </template> -->

              <template #cell(price)="data">
                {{ data.item.price + divisa }}
              </template>

              <template #cell(quantity)="data">
                <b-form-input
                  v-model="data.item.quantity"
                  id="cuantity"
                  type="number"
                  @blur="addProduct(data)"
                ></b-form-input>
                <small v-if="isValidQuantity(data.item)" class="text-danger">
                  {{ $t("pleaseEnterValidAmount") }}
                </small>
              </template>
            </b-table>

            <!-- List for mobile devices -->
            <div
              id="list-container"
              class="d-block d-md-none list-container"
              :class="{ 'mt-1': option === 1 }"
            >
              <b-list-group>
                <b-list-group-item
                  v-for="item in items"
                  :key="item.idProducto"
                  class="flex-column align-items-start border border-primary rounded mb-1"
                >
                  <div class="d-flex w-100 justify-content-between m-0 p-0">
                    <div class="d-flex justify-content-start">
                      <input
                        :checked="item.selected || false"
                        type="checkbox"
                        @click="toggleSelectList(item)"
                        class="1 mr-1"
                      />
                      <p class="!mb-0 mt-1 mr-1">
                        <strong> {{ item.name }}</strong>
                      </p>
                    </div>
                  </div>

                  {{ $t(labelHeader("cost")) }} : {{ item.price }} {{ divisa }}
                  <br />
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <b-form-input
                      v-model="item.quantity"
                      id="cuantity"
                      type="number"
                      @blur="addProductList(item)"
                    ></b-form-input>
                    <small v-if="isValidQuantity(item)" class="text-danger">
                      {{ $t("pleaseEnterValidAmount") }}
                    </small>
                  </div>
                  <br />
                </b-list-group-item>
                <b-list-group-item v-if="items.length == 0" class="text-center">
                  {{ $t("notRegister") }}
                </b-list-group-item>
                <b-list-group-item v-if="loading" class="text-center">
                  <b-spinner variant="success"></b-spinner>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-card-body>

          <b-card-footer>
            <b-row>
              <b-col
                cols="6"
                class="d-flex align-items-center justify-content-end ml-auto"
              >
                <b-button class="mr-1" @click="hideModal">
                  {{ $t("cancel") }}
                </b-button>

                <b-button class="m-0" variant="primary" @click="toggleModal">
                  {{ $t("add") }}
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </b-modal>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardFooter,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BModal,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BFormSelect,
  BFormRadio,
  BFormRadioGroup,
  BFormInvalidFeedback,
  BFormCheckboxGroup,
  VBToggle,
  VBTooltip,
  BSpinner,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import Ripple from "vue-ripple-directive";
import Filterss from "../../components/filters/Filterss.vue";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import {
  allProducts,
  deleteProduct,
  allCateg,
} from "@core/api/request/products";
import moment from "moment";
import { deleteProductOrder } from "@core/api/request/orders";
import {
  PROMOTION_TYPE,
  hasPromotion as productHasPromotion,
  isPromotionType,
  productTotal as calculateProductTotal,
  promotionalPrice as calculatePromotionalPrice,
  promotionApplies as productPromotionApplies,
  regularPrice as calculateRegularPrice,
} from "./orderProductPricing";

export default {
  props: {
    selectedProductsGet: {
      type: Array,
      default: () => [],
    },
    option: {
      type: Number,
      default: () => 1,
    },
    blockStatus: {
      type: Boolean,
      default: () => false,
    },
    referenceDate: {
      type: [String, Date],
      default: null,
    },
  },

  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardFooter,
    BRow,
    BCol,
    BFormInput,
    BModal,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormCheckbox,
    BForm,
    BFormTextarea,
    BFormSelect,
    BFormRadio,
    BFormRadioGroup,
    BFormInvalidFeedback,
    BFormCheckboxGroup,
    VBToggle,
    VBTooltip,
    ValidationProvider,
    ValidationObserver,
    Filterss,
    BSpinner,
    BListGroup,
    BListGroupItem,
  },

  data() {
    return {
      showModal: false,
      products: [],
      selectedProducts: [],
      fildsToFilters: [
        {
          name: "name",
          title: "nombre",
          placeholder: "nombre",
          type: "text",
          reference: "name",
          visible: true,
        },
        {
          name: "category",
          title: "Categoría",
          placeholder: "Seleccione una categoría",
          type: "select",
          options: [],
          visible: true,
        },
      ],
      listCategories: [],
      headVariant: "light",
      striped: false,
      outlined: false,
      bordered: true,
      borderless: false,
      loading: false,
      totalRows: null,
      currentPage: 1,
      perPage: 10,
      fieldsModalDesktop: [
        { label: "select", key: "select", sortable: true },
        // { label: "photo", key: "photo", sortable: true },
        { label: "name", key: "name", sortable: true },
        { label: "price", key: "price", sortable: false },
        { label: "quantity", key: "quantity", sortable: false },
      ],

      fieldsDesktop: [
        { label: "name", key: "name", sortable: true },
        { label: "promotion", key: "promotion", sortable: false },
        { label: "unit_price", key: "price", sortable: false },
        { label: "quantity", key: "quantity", sortable: false },
        { label: "total", key: "total", sortable: false },
        // { label: "action", key: "actions", sortable: false },
      ],

      items: [],
      appliedFilters: {},
      companyGuid: null,
      productsSelected: [],
      photoValidate: false,
      totalPages: null,
      hasNextPage: true,
      produtFilter: "",
      nameProduct: "",
      timeout: null,
      optionChargeItems: null,
      productsCreate: [],
    };
  },

  computed: {
    seletedProductsFunction() {
      return this.selectedProductsGet;
    },

    divisa() {
      return this.$store.state.appConfig.divisa || "USD";
    },
  },

  created() {
    localize("es");
    if (this.option === 1) {
      this.productsSelected = this.selectedProductsGet;
      this.fieldsDesktop.push({
        label: "action",
        key: "actions",
        sortable: false,
      });
    }
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.loadProducts();
    },
  },

  mounted() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadProducts();
    this.loadCategory();
  },

  methods: {
    formatAmount(value) {
      const amount = Number(value);
      if (!Number.isFinite(amount)) return "-";
      return amount.toLocaleString(this.$i18n.locale || "es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    hasPromotion(product) {
      return productHasPromotion(product, this.referenceDate || new Date());
    },

    isPercentagePromotion(product) {
      return (
        isPromotionType(
          product,
          PROMOTION_TYPE.percentage,
          this.referenceDate || new Date(),
        )
      );
    },

    isFixedPricePromotion(product) {
      return (
        isPromotionType(
          product,
          PROMOTION_TYPE.fixedPrice,
          this.referenceDate || new Date(),
        )
      );
    },

    isVolumePromotion(product) {
      return (
        isPromotionType(
          product,
          PROMOTION_TYPE.volume,
          this.referenceDate || new Date(),
        )
      );
    },

    isComboPromotion(product) {
      return (
        isPromotionType(
          product,
          PROMOTION_TYPE.combo,
          this.referenceDate || new Date(),
        )
      );
    },

    regularPrice(product) {
      return calculateRegularPrice(product);
    },

    promotionalPrice(product) {
      return calculatePromotionalPrice(product);
    },

    promotionApplies(product) {
      return productPromotionApplies(
        product,
        this.referenceDate || new Date(),
      );
    },

    effectivePrice(product) {
      if (this.promotionApplies(product) && !this.isComboPromotion(product)) {
        return this.promotionalPrice(product);
      }

      return this.regularPrice(product);
    },

    productTotal(product) {
      return calculateProductTotal(
        product,
        this.referenceDate || new Date(),
      );
    },

    promotionCondition(product) {
      if (this.isPercentagePromotion(product)) {
        const percentage = Number(product?.discountPercentage);
        if (Number.isFinite(percentage) && percentage > 0) {
          return this.$t(this.label("promotionPercentage"), {
            percentage: this.formatRate(percentage),
          });
        }
      }

      if (this.isVolumePromotion(product)) {
        const minimum = Number(product?.promotionMinQuantity);
        if (!Number.isFinite(minimum) || minimum <= 0) return "";

        return this.$t(
          this.label(
            product?.isCumulative === true ||
              product?.isCumulative === 1 ||
              String(product?.isCumulative).toLowerCase() === "true"
              ? "promotionEveryQuantity"
              : "promotionOnceQuantity",
          ),
          {
            quantity: minimum,
          },
        );
      }

      if (this.isComboPromotion(product)) {
        const quantity = Number(product?.quantityOfProducts);
        const price = Number(product?.priceNow);
        if (
          Number.isFinite(quantity) &&
          quantity > 0 &&
          Number.isFinite(price) &&
          price >= 0
        ) {
          return this.$t(this.label("promotionCombo"), {
            quantity,
            price: this.formatAmount(price),
            currency: this.divisa,
          });
        }
      }

      if (this.isFixedPricePromotion(product)) {
        return this.$t(this.label("promotionSpecialPrice"));
      }

      return "";
    },

    formatRate(value) {
      const rate = Number(value);
      return Number.isFinite(rate)
        ? rate.toLocaleString(this.$i18n.locale || "es-VE")
        : 0;
    },

    roundedNumber(value) {
      if (value !== NaN) {
        return value?.toFixed(2);
      } else {
        return 0;
      }
    },

    updateItem(item, index) {
      this.items[index] = { ...item };
    },

    applyFilters(filters) {
      this.appliedFilters = filters;

      this.loadProductsWithFIlters(
        filters.name == null ? null : filters.name,
        filters.category == null ? null : filters.category.id,
      );
    },

    resetFilters() {
      this.appliedFilters = {};

      this.loadProducts();
    },

    label(field) {
      return `pages.orders.form.label.${field}`;
    },

    labelHeader(field) {
      return `pages.products.table.tableHeader.${field}`;
    },

    tagsColor(stock) {
      if (stock > 0) return "light-success";
      else return "light-danger";
    },

    chargeParams() {
      const arrParams = [];

      if (this.produtFilter !== "") {
        arrParams.push(`name,${this.produtFilter}`);
      }

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);
      arrParams.push(`active,${true}`);
      return getParams(arrParams);
    },

    chargeParamsWhitFilters(name, category) {
      const arrParams = [];

      arrParams.push(`page,${this.currentPage}`);

      arrParams.push(`rows,${this.perPage}`);

      arrParams.push(`guidCompany,${this.companyGuid}`);
      arrParams.push(`active,${true}`);
      if (name != null) arrParams.push(`name,${name}`);
      if (category != null) arrParams.push(`idCatCategory,${category}`);
      return getParams(arrParams);
    },

    // Hay que mejorar la logica de carga de productos
    loadProducts() {
      // console.log("Que contiene el has", this.hasNextPage);
      if (this.hasNextPage) {
        const param = this.chargeParams();

        // console.log("ARRAY LOAD", this.items);
        allProducts(param)
          .then((resp) => {
            const data = _.get(resp, "data");
            if (data) {
              if ((this.optionChargeItems = 2)) {
                this.items = [...this.items, ...data?.items];
                this.items = this.eliminarObjetos(
                  this.items,
                  this.productsSelected,
                );
              } else {
                this.items = [...this.items];
                this.items = this.eliminarObjetos(
                  this.items,
                  this.productsSelected,
                );
              }
              this.totalRows = data?.totalRows || 0;
              this.totalPages = data?.totalPages || 0;
              this.hasNextPage = this.currentPage < this.totalPages;
            }
          })
          .catch((error) => {
            console.log("error", error);
            this.alertToast("danger", `Alerta codigo`, error.data?.message);
          });
      }
    },

    // lo metodos deben llamarse en ingles
    eliminarObjetos(item1, item2) {
      // console.log("ITEMS CONTENT", item1, item2);
      return item1.filter(
        (obj1) => !item2.some((obj2) => obj1.idProducto === obj2.idProducto),
      );
    },

    // lo metodos deben llamarse en ingles
    actualProducts(items, itemsSelected) {
      this.items = items.filter(
        (item) => !itemsSelected.some((i) => item.idProducto === i.idProducto),
      );
      console.log("ITEMS", this.items);
    },

    mergeItems(arr1, arr2) {
      const item2Map = new Map(
        arr2.map((obj) => [obj.idProducto, obj.quantity]),
      );

      return arr1.map((obj) => ({
        ...obj,
        quantity: item2Map.get(obj.idProducto) || null,
      }));
    },

    async FilterProduct() {
      const param = this.chargeParams();
      if (this.currentPage == 1) {
        this.loading = !this.loading;
      }

      await allProducts(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = [...data?.items];
          this.totalRows = data?.totalRows || 0;
          this.totalPages = data?.totalPages || 0;
          this.hasNextPage = this.currentPage < this.totalPages;
          if (this.currentPage == 1) {
            this.loading = !this.loading;
          }
        })
        .catch((error) => {
          if (this.currentPage == 1) {
            this.loading = !this.loading;
          }
          console.log("error", error);
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    handleScroll(e) {
      this.optionChargeItems = 2;
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        this.currentPage++;
        this.loadProducts();
      }
    },

    loadProductsWithFIlters(name, category) {
      const param = this.chargeParamsWhitFilters(name, category);
      this.loading = !this.loading;
      allProducts(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.items = data?.items || [];
          this.totalRows = data?.totalRows || 0;
          this.loading = !this.loading;
          // console.log("reps", resp);
          if (resp.data == null) {
            this.alertToast(
              "danger",
              `Error`,
              `No se encontraron coincidencias`,
            );
          }
        })
        .catch((error) => {
          // console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    // para que se usa ?
    loadCategory() {
      allCateg()
        .then((result) => {
          this.listCategories = _.get(result, "data.listOfItems.items", []);

          const transformedItems = this.listCategories.map((item) => ({
            ...item,
            label: item.name,
            name: undefined,
          }));

          this.fildsToFilters[1].options = transformedItems;
        })
        .catch((error) => {
          console.log("error", error);
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    addProduct(data) {
      if (data.item.quantity > data.item.stock) {
        data.item.quantity = 0;
      }

      if (data.item.selected && data.item.quantity > 0) {
        const productIndex = this.productsSelected.findIndex(
          (product) => product.idProducto === data.item.idProducto,
        );

        if (productIndex !== -1) {
          this.productsSelected[productIndex].quantity = data.item.quantity;
        } else {
          const random = () => ((1 + Math.random()) * 0x100000) | 0;
          const block = () =>
            (+moment.now() + random() + random() + random()).toString(16);
          const uuidTem = `${block()}-${block()}-${block()}`;
          data.item.uuidTem = uuidTem;
          this.productsSelected.push({ ...data.item });
        }
      } else if (!data.item.selected) {
        this.productsSelected = this.productsSelected.filter(
          (product) => product.idProducto !== data.item.idProducto,
        );
      }
    },

    addProductList(item) {
      if (item.quantity > item.stock) {
        item.quantity = 0;
      }

      if (item.selected && item.quantity > 0) {
        const productIndex = this.productsSelected.findIndex(
          (product) => product.idProducto === item.idProducto,
        );

        if (productIndex !== -1) {
          this.productsSelected[productIndex].quantity = item.quantity;
        } else {
          const random = () => ((1 + Math.random()) * 0x100000) | 0;
          const block = () =>
            (+moment.now() + random() + random() + random()).toString(16);
          const uuidTem = `${block()}-${block()}-${block()}`;
          item.uuidTem = uuidTem;
          this.productsSelected.push({ ...item });
        }
      } else if (!item.selected) {
        this.productsSelected = this.productsSelected.filter(
          (product) => product.idProducto !== item.idProducto,
        );
      }
    },
    isValidQuantity(item) {
      return (
        item.selected &&
        (!item.quantity || item.quantity <= 0 || item.quantity > item.stock)
      );
    },

    toggleSelect(data) {
      console.log("Recibe", data);
      this.$set(data.item, "selected", !data.item.selected);

      this.$nextTick(() => {
        this.addProduct(data);
      });
    },

    toggleSelectList(item) {
      console.log("Recibe", item);
      this.$set(item, "selected", !item.selected);

      this.$nextTick(() => {
        this.addProductList(item);
      });
    },

    hideModal() {
      this.$root.$emit("bv::hide::modal", "modal-products-list", "#btnShow");
    },

    toggleModal() {
      this.$emit("products-selected", this.productsSelected);
      this.$root.$emit(
        "bv::toggle::modal",
        "modal-products-list",
        "#btnToggle",
      );

      this.items.forEach((item) => {
        item.selected = false;
        item.quantity = 0;
      });
    },

    // para que se usa ?
    showPhoto(item) {
      // console.log("PRUEBA FOTO PRDUCTO", item.urlPhoto);
      if (item.urlPhoto) {
        const url = item.urlPhoto;
        this.photoValidate = true;
        return url;
      } else {
        this.photoValidate = false;
      }
    },

    onProductSearch(ev) {
      if (!ev) {
        this.currentPage = 1;
        this.items = [];
        this.hasNextPage = true;
        this.optionChargeItems = 1;
        this.loadProducts();
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.currentPage = 1;
        this.items = [];
        this.hasNextPage = true;
        this.optionChargeItems = 1;
        this.loadProducts();
      }, 1000);
    },

    onDelete(model) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          console.log("model", model);
          if (model.item?.uuidTem) {
            const index = this.seletedProductsFunction.findIndex(
              (product) => product.uuid === model.item?.uuidTem,
            );
            this.seletedProductsFunction.splice(index, 1);
          } else {
            showLoading();
            const arrParams = getParams([
              `idOrder,${model.item?.idOrder}`,
              `guidProduct,${model.item?.guid}`,
            ]);
            deleteProductOrder(arrParams)
              .then((resp) => {
                stopLoading();
                const status = _.get(resp, "status");
                if (status == 500) {
                  this.message(
                    this.$t("Alert"),
                    this.$t("registerHasntDeleted"),
                    "error",
                  );
                  return;
                }
                this.$emit("delete-product");
                this.message(
                  this.$t("Deleted"),
                  this.$t("registerHasBeenDeleted"),
                  "success",
                );
              })
              .catch((error) => {
                console.log("error", error);
                stopLoading();
                this.alertToast("danger", this.$t("codeAlert"), error.message);
              });
          }
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },

    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
  directives: { "b-toggle": VBToggle, "b-tooltip": VBTooltip, Ripple },
};
</script>

<style lang="scss" scoped>
.card-body-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2px;
}

.order-products-card {
  overflow: hidden;
  border: 0;
  border-radius: 0.65rem;
  box-shadow: 0 4px 18px rgba(34, 41, 47, 0.08);
}

.products-card-header,
.products-heading,
.products-heading-icon {
  display: flex;
  align-items: center;
}

.products-card-header {
  justify-content: space-between;
  gap: 1rem;
  padding: 1.5rem;
}

.products-heading {
  min-width: 0;
  gap: 0.85rem;
}

.products-heading-icon {
  justify-content: center;
  width: 2.65rem;
  height: 2.65rem;
  flex: 0 0 2.65rem;
  color: #28c76f;
  border-radius: 0.65rem;
  background: rgba(40, 199, 111, 0.12);
}

.products-card-body {
  padding: 0 1.5rem 1.5rem;
}

#products-selected-table-edit {
  margin-bottom: 0;
}

@media (max-width: 767.98px) {
  .products-card-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .products-card-body {
    padding: 0 1rem 1rem;
  }
}

// .list-container {
//   border: 1px solid gray;
//   border-radius: 2px;
// }

.ul-content {
  list-style-type: none;
  padding: 0;
}

.ul-list-content {
  display: flex;
  justify-content: space-around;
  margin: 1rem 2rem 1rem 0;
}

.col-for-list {
  display: flex;
  justify-content: center;
}

.table-container {
  height: 400px;
  /* Ajusta la altura según tus necesidades */
  overflow-y: auto;
}

.table-container-first {
  // height: 344px;
  /* Ajusta la altura según tus necesidades */
  overflow-y: auto;
}

.list-container {
  /* Ajusta el alto según tus necesidades */
  overflow-y: auto;
}

.text-line-through {
  text-decoration: line-through;
}
</style>
